// --------------------------------------------------------
// Medical Record List
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from 'react'
import { executeWithDelay } from '../../helpers/HelperFunctions';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../..';
import { CompanyListContainer } from '../company/CompanyList.styled';
import { GeneralContainer, ListItemContainer, TableData, Text, TextLink } from '../../components/UI/generalLayout/Layout.styled';
import { CircularProgress, InputAdornment, OutlinedInput, Table, Box, Typography } from '@mui/material';
import { ListHeaderContainer, ListHeaderItemContainer, MobileContainer } from './MedicalRecordList.styled';
import { CategoryService } from '../../core/http/service/CategoryService';
import Search from "@mui/icons-material/Search";
import BusinessIcon from "@mui/icons-material/Business";
import BaseResponse from '../../models/core/BaseResponse';
import Category from '../../models/core/careLine/Category';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import ScreenHeader from '../../components/UI/screenHeader/ScreenHeader';
import Unit from '../../models/core/unit/Unit';
import CareLineDropdown from '../../components/dropdown/CareLineDropdown';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import * as appointmentActions from "../../store/actions/appointment";
import * as unitActions from '../../store/actions/unit';
import RegistrarJustificativaModal from '../../components/registrarJustificativaModal/RegistrarJustificativaModal';
import Colors from '../../constants/Colors';
import { ItemInfoContainer, ViewEditContainer } from '../../components/companyListItem/CompanyListItemMobile.styled';
import { fetchProntuarioLimpar } from '../../store/actions/appointment';
import { useLocation, useNavigate } from 'react-router-dom';
import { DivProntuario } from '../../components/cardPainelConsults/CardPainelConsults.styled';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as personActions from "../../store/actions/person";
import { Paths } from '../../enums/Paths';
import moment from "moment";
import { SchedulingService } from '../../core/http/service/SchedulingService';
import { PersonService } from '../../core/http/service/PersonService';
import { atualizaAcessoProntuario } from '../../store/actions/person';

// --------------------------------------------------------
// APPOINTMENT PANEL INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

interface YearLabel {
  nome: string;
  id: string;
}

function MedicalRecordList(): JSX.Element {
    // --------------------------------------------------------
    // APPOINTMENT PANEL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const { prontuarios } = useSelector((state: any) => state.appointment);    
    const { pessoa } = useSelector((state: any) => state.person);
    const [selectedUnit, setSelectedUnit] = useState<any>({ id: '', nome: '' })
    const [nomeOuProfissionalSearchQuery, setNomeOuProfissionalSearchQuery] = useState('')
    const [activeUnits, setActiveUnits] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useAppDispatch()
    const units: Unit[] = useSelector((state: any) => state.unit.units)
    const hasSelectedUnit = selectedUnit.id !== '';    
    const [showModalAcessoProntuario, setShowModalAcessoProntuario] = useState(false)
    const location = useLocation();
    const { currentProfile, userInfo } = useSelector((state: any) => state.login);
    const isTecEnfermagem = currentProfile === "TEE";
    const navigate = useNavigate();
    const [redireciona, setRedireciona] = useState(false);
    const allValue = { nome: "Todos", id: "" };
    const [selectedYear, setSelectedYear] = useState<YearLabel>(allValue);
    const [profissionalId , setProfissionalId] = useState("");
    const [pacienteId , setPacienteId] = useState("");

    const fetchUnits = useCallback(async () => {
        await dispatch(unitActions.fetchUnitList());
    }, [])

    useEffect(() => {
        fetchUnits();
        dispatch(fetchProntuarioLimpar());
      }, [dispatch]);
          
    useEffect(() => {
        dispatch(fetchProntuarioLimpar());
    }, [dispatch, location]);

    useEffect(() => {
        if (!!units) {
            const unidadesAtivas: any[] = []
            units.forEach((unit: Unit) => {
                if (!unit.inativo) {
                    unidadesAtivas.push({ nome: unit.nomeFantasia, id: unit.id })
                }
            })
            setActiveUnits(unidadesAtivas)
        }
    }, [units])

    useEffect(() => {
        if (hasSelectedUnit && nomeOuProfissionalSearchQuery && nomeOuProfissionalSearchQuery.trim().length >= 3) {
            executeWithDelay(500, async () => {
                await dispatch(appointmentActions.fetchProntuario(selectedUnit, nomeOuProfissionalSearchQuery.trim()));
            })
        } else {
            dispatch(fetchProntuarioLimpar());
        }
    }, [nomeOuProfissionalSearchQuery, selectedUnit, hasSelectedUnit, dispatch]); 

    function formatDateToBR(dateString: any) {
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      }

    const maskCPF = (value: string) => {
        return value
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2') 
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      };

    function redirecionarProntuarioPaciente(pacienteId: string) {

        
        setPacienteId(pacienteId);
        setProfissionalId(userInfo.id);
        setRedireciona(true);

        if(isTecEnfermagem){
            setShowModalAcessoProntuario(true);
        }else{
            //redireciona
            dispatch(atualizaAcessoProntuario(true));
            navigateToProntuario(pacienteId);
        }
        
    }

    const navigateToProntuario = async (pacienteId: string) => {

        const service: PersonService = new PersonService();        
        try {
            const result: any = await service.getPessoaById(pacienteId);

            if(result.status == 200){
                var pessoaAtual = result.data.data;
                navigate(Paths.Prontuario, { state: { pessoa: pessoaAtual } });
            }

        } catch (error: any) {
            console.log(error);
        }

    }

    return (
        <ContainerWithSidebar>
            <GeneralContainer>
                <ScreenHeader
                    screenTitle='Prontuário do Paciente'
                    onRightButtonClick={() => { }}
                    hasRightButton={false}
                    rightButtonText={''}
                />
                <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: '10px', marginTop: 10 }}>
                    <Text bold style={{ marginRight: 5, color: Colors.GRAY700 }}>Unidade: </Text>
                    <CareLineDropdown
                        placeholder='Selecione a Unidade'
                        style={{ width: isMobile ? '100%' : 340 }}
                        value={selectedUnit}
                        onChange={setSelectedUnit}
                        items={activeUnits}
                        disabled={false}
                    />
                </div>
                <div>                   
                    <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                        <OutlinedInput
                            style={{ borderRadius: "10px", width: isMobile ? "100%" : "450px", height: "45px", backgroundColor: "#fff" }}
                            id="outlined-adornment-amount"
                            startAdornment={
                                <InputAdornment position="start">
                                    <Search color="action" />
                                </InputAdornment>
                            }
                            endAdornment={
                                isLoading ? (
                                    <InputAdornment position="end">
                                        <CircularProgress size={20} color="primary" />
                                    </InputAdornment>
                                ) : null
                            }
                            placeholder={hasSelectedUnit ? "Buscar por nome de paciente ou profissional" : "Selecione uma unidade para pesquisar..."}
                            value={nomeOuProfissionalSearchQuery}
                            onChange={(event: any) => {
                                setNomeOuProfissionalSearchQuery(event.target.value)
                            }}
                        />
                    </div>
                </div>

                {!hasSelectedUnit ? (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "48px 24px",
                            marginTop: "32px",
                            backgroundColor: "#F8FAFC",
                            border: "1px dashed #CBD5E1",
                            borderRadius: "16px",
                            textAlign: "center",
                            gap: "12px",
                        }}
                    >
                        <BusinessIcon sx={{ fontSize: 48, color: Colors.SPM600, opacity: 0.85 }} />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E293B" }}>
                            Selecione uma Unidade para visualizar os Prontuários
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#64748B", maxWidth: 480, lineHeight: 1.5 }}>
                            Para realizar a busca e acessar a listagem de pacientes e prontuários, por favor escolha primeiro a unidade de atendimento no seletor acima.
                        </Typography>
                    </Box>
                ) : nomeOuProfissionalSearchQuery.trim().length < 3 ? (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "48px 24px",
                            marginTop: "32px",
                            backgroundColor: "#F8FAFC",
                            border: "1px dashed #CBD5E1",
                            borderRadius: "16px",
                            textAlign: "center",
                            gap: "12px",
                        }}
                    >
                        <Search sx={{ fontSize: 48, color: Colors.SPM600, opacity: 0.85 }} />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E293B" }}>
                            Digite o nome do paciente ou profissional
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#64748B", maxWidth: 480, lineHeight: 1.5 }}>
                            Informe ao menos 3 caracteres no campo de busca para pesquisar os prontuários nesta unidade.
                        </Typography>
                    </Box>
                ) : (
                    <div style={{ marginTop: 20 }}>
                        <>
                            {!isMobile && prontuarios && prontuarios.length > 0 && (
                                <Table style={{ width: "100%", marginTop: 10, borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <TableData width="38%"><Text bold style={{ color: Colors.GRAY700 }}>Nome</Text></TableData>
                                            <TableData width="23%"><Text bold style={{ color: Colors.GRAY700 }}>Nascimento</Text></TableData>
                                            <TableData width="20%"><Text bold style={{ color: Colors.GRAY700 }}>CPF</Text></TableData>
                                            <TableData width="19%"><Text bold></Text></TableData>
                                        </tr>
                                    </thead>
                                </Table>
                            )}                        
                            {isLoading && prontuarios.length === 0 ? (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, width: '100%' }}>
                                    <CircularProgress />
                                </div>
                            ) : prontuarios && prontuarios.length > 0 ? (
                                <CompanyListContainer style={{ marginBottom: isMobile ? 30 : 10, marginTop: 10 }}>
                                    {prontuarios.map((p: any) => (
                                        <ListItemContainer key={p.pacienteId}>
                                            {!isMobile ? (
                                                <Table key={p.pacienteId}>
                                                    <tbody>
                                                        <tr>
                                                            <TableData width="38%">
                                                                <Text style={{ fontWeight: 600, color: "#1E293B" }}>{p.nome}</Text>
                                                            </TableData>
                                                            <TableData width="23%">
                                                                <Text style={{ color: "#475569" }}>{formatDateToBR(p.dataNascimento)}</Text>
                                                            </TableData>
                                                            <TableData width="20%">
                                                                <Text style={{ color: "#475569" }}>{maskCPF(p.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'))}</Text>
                                                            </TableData>
                                                            <TableData width="19%">
                                                                <DivProntuario
                                                                    onClick={() => redirecionarProntuarioPaciente(p.pacienteId)}
                                                                >
                                                                    <span>PRONTUÁRIO</span>
                                                                    <ArrowForwardIosIcon style={{ fontSize: 13 }} />
                                                                </DivProntuario>
                                                            </TableData>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <MobileContainer key={p.pacienteId}>
                                                    <ItemInfoContainer style={{ textAlign: 'start' }}>
                                                        <Text bold color={Colors.GRAY900}>{p.nome}</Text>
                                                        <Text color="#8D8D8D" style={{ fontSize: 14, marginTop: -6 }}>
                                                            {formatDateToBR(p.dataNascimento)}
                                                        </Text>
                                                        <Text>{maskCPF(p.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'))}</Text>
                                                        <ViewEditContainer style={{ width: 200, marginTop: 8 }}>
                                                            <DivProntuario
                                                                onClick={() => redirecionarProntuarioPaciente(p.pacienteId)}
                                                            >
                                                                <span>PRONTUÁRIO</span>
                                                                <ArrowForwardIosIcon style={{ fontSize: 13 }} />
                                                            </DivProntuario>
                                                        </ViewEditContainer>
                                                    </ItemInfoContainer>
                                                </MobileContainer>
                                            )}
                                        </ListItemContainer>
                                    ))}
                                </CompanyListContainer>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px 20px', backgroundColor: '#F8FAFC', borderRadius: '12px', marginTop: 20, border: '1px border #E2E8F0' }}>
                                    <Text style={{ color: Colors.GRAY600, fontWeight: 500 }}>Nenhum resultado encontrado.</Text>
                                </div>
                            )}
                        </>
                    </div>
                )}
            </GeneralContainer>
            <RegistrarJustificativaModal
                visible = {showModalAcessoProntuario}
                profissionalId = {profissionalId}
                pacienteId = {pacienteId}                     
                onClose={()=>{ setShowModalAcessoProntuario(false) }} 
            />
        </ContainerWithSidebar>);

}

export default MedicalRecordList;
